export default __webpack_public_path__ + "static/media/151-wc.69c89860.png";